module.exports = __webpack_public_path__ + "img/32.c2abb224.jpg";